<template>
  <div class="product-offer-1" v-if="productOfferChecker(product) && offerStatus">
    <span class="badge product-offer-1-background badge-primary" v-if="offerType ==='number'">
      {{ $t('product.offer.offer', {offer: formatNumber(offer)}) }}
    </span>
    <span class="badge product-offer-1-background badge-primary" v-if="offerType ==='percent'">
      {{ $t('product.offer.percent', {percent: offerPercentValue}) }}
    </span>
  </div>
</template>

<script>
import {
  getProductPriceRange,
  getProductOfferRange,
  productOfferChecker
} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product'
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {OfferProps} from './ProductOfferProps'

export default {
  name: "ProductOffer1",
  data() {
    return {
      offer: false,
      price: 0,
      offerPercentValue: 0
    }
  },
  props: {
    product: {},
    ...OfferProps,
  },
  methods: {
    formatNumber,
    productOfferChecker,
    getProductPriceRange,
    getProductOfferRange,
    productOfferWrapper() {
      const variation = this.product.variation
      if (variation == 1) {
        const price = this.getProductOfferRange(this.product, 'object')['max'];
        return parseInt(price)
      }
      return this.product.offer
    },
    productPriceWrapper() {
      const variation = this.product.variation
      if (variation == 1) {
        return this.getProductPriceRange(this.product, 'object')['max']
      }
      return this.product.price
    },
    offerPercent(price, offer) {
      return Math.round((offer * 100) / price)
    },
    initOffer() {
      this.offer = this.productOfferWrapper(this.product)
      this.price = this.productPriceWrapper(this.product)
      this.offerPercentValue = this.offerPercent(this.price, this.offer)
    }
  },
  updated() {
    this.initOffer()
  },
  mounted() {
    this.initOffer()
  },
}
</script>

<style scoped>
.product-offer-1 {
  z-index: 2;
  margin: 10px;
}
</style>